const DialPhoneStatusEnum = Object.freeze({
    IDLE: "idle",
    COMPOSING: "composing",
    DIALING: "dialing",
    RINGING: "ringing",
    SPEAKING: "speaking",
    ENGAGED: "engaged"
  });
  
  export default DialPhoneStatusEnum;